import { useFavicon, useTitle } from "react-use";

import ApolloProvider from "_graphql";
import BatchReportProvider from "providers/batch-report-provider";
import LayoutProvider from "layouts";
import { MantineProvider } from "@mantine/core";
import RoutesProvider from "router";
import { Toaster } from "react-hot-toast";
import { Tooltip } from "react-tooltip";
import { getAppDetails } from "router/filter";

// import TranslationProvider from 'translation';

function App() {
    const { name, tLogo } = getAppDetails();
    useTitle(`PlaceIT - Lite | ${name}`);
    useFavicon(tLogo);
    return (
        <MantineProvider>
            <ApolloProvider>
                <RoutesProvider>
                    <BatchReportProvider>
                        <LayoutProvider />
                    </BatchReportProvider>
                    <Tooltip id="global-tooltip" />
                    <Toaster />
                </RoutesProvider>
            </ApolloProvider>
        </MantineProvider>
    );
}

export default App;
